export default "__VITE_ASSET__ff5fc571__"